export async function uploadFileToS3(file, signedUrl) {
  
  const response = await fetch(signedUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  });

  // Check for errors before attempting to parse a response
  if (!response.ok) {
    let errorText = await response.text();
    throw new Error(`Failed to upload file to S3: ${errorText}`);
  }

  return response.url.split('?')[0]
  // Optionally, if you expect JSON, first check if there's any content.
  const contentLength = response.headers.get('content-length');
  if (contentLength && parseInt(contentLength) > 0) {
    const json = await response.json();
    console.log(json);
  } else {
    console.log('File uploaded successfully with no JSON response.');
  }
}
